/**
 * BUSINESS LOGIC: SOCCER (FOOTBALL) OVERLAY
 */
import { 
    GetSoccerConfig as DLGetSoccerConfig,
    SetSoccerConfig as DLSetSoccerConfig,
    ShowSoccerOverlay as DLShowSoccerOverlay,
    HideSoccerOverlay as DLHideSoccerOverlay
} from './../DL/Soccer'

export const GetSoccerConfig = async () => {
    return await DLGetSoccerConfig();
};

export const SetSoccerConfig = async (config) => {
    // Validaciones básicas de rangos
    if (config.scale < 0.1) config.scale = 0.1;
    if (config.titleSize < 0.1) config.titleSize = 0.1;
    if (config.numberSize < 0.1) config.numberSize = 0.1;
    if (config.thanksSize < 0.1) config.thanksSize = 0.1;
    if (config.logoScale < 0.1) config.logoScale = 0.1;
    
    if (config.offsetX < -1920) config.offsetX = -1920;
    if (config.offsetY < -1080) config.offsetY = -1080;
    if (config.offsetX > 1920) config.offsetX = 1920;
    if (config.offsetY > 1080) config.offsetY = 1080;

    return await DLSetSoccerConfig(config);
};

export const ShowSoccerOverlay = async () => {
    return await DLShowSoccerOverlay();
};

export const HideSoccerOverlay = async () => {
    return await DLHideSoccerOverlay();
};
